import Cookies from "universal-cookie";
const cookies = new Cookies();

class CookieService {
  static setCookie(key, value) {
    cookies.set(key, value, { path: "/" });
  }
  static getCookie(key) {
    return cookies.get(key);
  }
}

export default CookieService;
